import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const EVENT_TICKETS_EVENT_TICKET_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/event-tickets',
        iconClass: 'fas fa-ticket',
        name: '::Menu:EventTickets',
        layout: eLayoutType.application,
        requiredPolicy: 'Mandir.EventTickets',
      },
    ]);
  };
}
